import {
  IS_TESTING_ENVIRONMENT,
  PROD_DEALER_SEARCH_URL,
  PROD_ONE_GRAPH_URL,
  QA_DEALER_SEARCH_URL,
  QA_ONE_GRAPH_URL,
} from '../constants/environment';

export function getOneGraphUrl() {
  return IS_TESTING_ENVIRONMENT ? QA_ONE_GRAPH_URL : PROD_ONE_GRAPH_URL;
}

export function getDealerSearchUrl() {
  return IS_TESTING_ENVIRONMENT ? QA_DEALER_SEARCH_URL : PROD_DEALER_SEARCH_URL;
}
